import { render, staticRenderFns } from "./WorkIconButton.vue?vue&type=template&id=73decb1e&scoped=true"
import script from "./WorkIconButton.vue?vue&type=script&lang=js"
export * from "./WorkIconButton.vue?vue&type=script&lang=js"
import style0 from "./WorkIconButton.vue?vue&type=style&index=0&id=73decb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73decb1e",
  null
  
)

export default component.exports